import { useMutation } from '@apollo/client';
import { DELETE_USER_MUTATION } from '../../services/apollo/mutations/userMutations';

const useDeleteAccount = () => {
  const [deleteUser, { loading, error, data }] = useMutation(DELETE_USER_MUTATION, {
    onCompleted: () => {
      console.log('Account successfully deleted');
    },
    onError: (error) => {
      console.error('Error deleting account:', error);
    },
  });

  return { deleteUser, loading, error, data };
};

export default useDeleteAccount;